import { z } from 'zod';

export const productImportIssueSchema = z.object({
    message: z.string(),
    path: z.array(z.union([z.string(), z.number()])).default([]),
    code: z.string().optional(),
});

export type ProductImportIssueSchema = z.infer<typeof productImportIssueSchema>;
